// Identifies the Microbiome Age submetric by gut_vaginal_health.category_key.
export const MICROBIOME_AGE_CATEGORY_KEY = 'microbiome_age';
// Years of bar drawn either side of the kit's own bands. Bounds are
// floor(age) ∓ 13.5 and the percentile clamp caps the offset at 30.31 y, so
// ±31.5 total puts the value inside the bar by construction.
const BAR_PADDING_YEARS = 18;
// The model never predicts below adulthood, so the bar never starts under 18.
const BAR_MIN_AGE = 18;
// Builds the 4-band array RangesGraph consumes from a single
// microbiome_age_evaluation_ranges row.
//
// The bar edges come from the row rather than the metric's scale_bar_min/max:
// on a fixed 18–151 bar the four bands shared ~20% of the width, leaving the
// rest flat green and red.
//
// Bands (per science team's front-end data guide):
//   green:  [barMin, lower_bound)      → Low
//   grey:   [lower_bound, mid_bound)   → Typical
//   orange: [mid_bound,  upper_bound)  → Borderline High
//   red:    [upper_bound, barMax]      → High
export function buildMicrobiomeAgeBands(row) {
    const lower = Number(row.lower_bound);
    const mid = Number(row.mid_bound);
    const upper = Number(row.upper_bound);
    const barMin = Math.max(BAR_MIN_AGE, lower - BAR_PADDING_YEARS);
    const barMax = upper + BAR_PADDING_YEARS;
    const base = {
        name: 'Microbiome age',
        sci_version: row.version,
        gut_vaginal_health_id: row.sex === 'M' ? 980 : 981,
    };
    return [
        {
            ...base,
            id: 'microbiome-age-low',
            evaluation_color: 'green',
            range_lower: barMin,
            range_upper: lower,
        },
        {
            ...base,
            id: 'microbiome-age-typical',
            evaluation_color: 'grey',
            range_lower: lower,
            range_upper: mid,
        },
        {
            ...base,
            id: 'microbiome-age-borderline-high',
            evaluation_color: 'orange',
            range_lower: mid,
            range_upper: upper,
        },
        {
            ...base,
            id: 'microbiome-age-high',
            evaluation_color: 'red',
            range_lower: upper,
            range_upper: barMax,
        },
    ];
}
//# sourceMappingURL=buildMicrobiomeAgeBands.js.map